<template>
    <div class="evaluation">
        <div class="evaluation-top">
            <div class="evaluation-top-title">测评考试</div>
            <div class="evaluation-top-desc">提高文明素质  严肃考风考纪</div>
        </div>
        
        <!-- 考试列表 -->
        <div class="exam-list">
            <div v-if="!loading && finished && examList.length === 0" class="empty-state">
                <van-empty description="暂无考试" />
            </div>
            <van-list
                v-else
                v-model="loading"
                :finished="finished"
                @load="onLoad"
            >
                <div class="exam-item" v-for="(item, index) in examList" :key="item.id || index">
                    <div class="exam-content">
                        <div class="icon-wrapper">
                            <van-icon name="records" color="#00BCD4" size="16" />
                        </div>
                        <div class="exam-info">
                            <div class="exam-title">{{ item.title }}</div>
                            <div class="exam-action">
                                <div class="exam-date">{{ formatDate(item.examBeginTime) }}</div>
                                <van-button 
                                    type="info" 
                                    size="small"
                                    round
                                    @click="handleExamAction(item)"
                                >我要考试</van-button>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import { getMyToBeTested } from '@/api/index.js';
    import moment from 'moment';
    
    export default {
        components: {},
        props: {},
        data() {
            return {
                examList: [],
                pageNum: 1,
                pageSize: 20,
                loading: false,
                finished: false,
                total: 0
            };
        },
        watch: {},
        computed: {},
        created() {
            // 首次加载
            this.loadExamList(false);
        },
        mounted() {},
        methods: {
            onLoad() {
                // 下拉加载更多
                this.loadExamList(true);
            },
            loadExamList(isLoadMore = false) {
                if (this.loading || this.finished) return;
                
                this.loading = true;
                if (!isLoadMore) {
                    this.pageNum = 1;
                    this.finished = false;
                }
                const data = {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                };
                
                getMyToBeTested(data).then(res => {
                    this.loading = false;
                    
                    const records = res.data?.records || [];
                    const total = res.data?.total || 0;
                    
                    if (isLoadMore) {
                        // 追加数据
                        this.examList = [...this.examList, ...records];
                    } else {
                        // 首次加载
                        this.examList = records;
                    }
                    
                    // 判断是否加载完成
                    this.total = total;
                    if (this.examList.length >= total || records.length < this.pageSize) {
                        this.finished = true;
                    } else {
                        this.pageNum++;
                    }
                }).catch(err => {
                    this.loading = false;
                    this.finished = true;
                });
            },
            formatDate(dateStr) {
                if (!dateStr) return '';
                // 格式化日期为：2025年08月26日
                return moment(dateStr).format('YYYY年MM月DD日');
            },
            handleExamAction(item) {
                // 开始考试 - 跳转到考试详情页
                // 将 notice 存储到 Vuex（时间统计在 startQuiz 接口中统一处理）
                if (item.notice) {
                    this.$store.commit('setExamNotice', item.notice);
                }
                this.$router.push({ 
                    path: '/exam-detail', 
                    query: { 
                        id: item.id,
                        title: item.title
                    } 
                });
            }
        },
    };
</script>

<style scoped  lang='scss'>
.evaluation {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

.evaluation-top{
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 90px 15px 0;
    width: 100%;
    height: 300px;
    background: url('~@/assets/image/evaluation-top-bg.png') no-repeat center center;
    background-size: 100% 100%;
    .evaluation-top-title{
        font-size: 24px;
        font-weight: bold;
        color: #fff;
    }
    .evaluation-top-desc{
        font-size: 15px;
        color: #fff;
    }
}

.exam-list {
    flex: 1;
    padding: 20px 15px;
    margin-top: -80px;
    position: relative;
    z-index: 2;
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
    border-radius: 20px 20px 0 0;
}

.exam-item {
    background: #fff;
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s;
    
    &:active {
        transform: scale(0.98);
    }
    &:last-child {
        margin-bottom: 0;
    }
}

.exam-content {
    flex: 1;
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.icon-wrapper {
    width: 24px;
    height: 24px;
    background: rgba(0, 188, 212, 0.1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.exam-info {
    flex: 1;
    min-width: 0;
}

.exam-title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.exam-action {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .exam-date {
        font-size: 13px;
        color: #999;
    }
    .van-button {
        padding: 0 12px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
    }
}

.empty-state {
    padding: 60px 20px;
    text-align: center;
}
</style>
